<template>
  <el-dialog
    title="图文信息设置"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="95px">
      <el-form-item
        label="图文详情："
        prop="v">
        <desc-images-new
          v-model="ruleForm.v"
          edit />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import DescImagesNew from '../public/desc-images-new.vue'
export default {
  name: 'EntPicModal',
  components: { DescImagesNew },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { v: [], k: 'ent-picture-info', topic: 'ent-picture-info' },
      rules: {
        v: [{ required: true, message: '请上传图片', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm.v = []
    },
    getkeyvaluebykey() {
      this.loading = true
      this.$store.dispatch('appraise/getkeyvaluebykey', {
        payload: { topic: 'ent-picture-info', k: 'ent-picture-info' },
        success: (res) => {
          this.loading = false
          this.ruleForm.v = this.$splitImage(res.data.v)
          this.visible = true
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`appraise/setkeyvalue`, {
            payload: {
              ...this.ruleForm,
              v: this.ruleForm.v.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.visible = false
              this.$message.success('设置成功')
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
